import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 20px;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const DateFilterContainer = styled.div`
  padding: 20px;
  background-color: ${props => props.theme.colors.card};
  border-radius: 0 0 12px 12px;
  border: 1px solid ${props => props.theme.colors.border_grey}30;
  border-top: none;
`;

